import { translationsWithFallback } from "helpers/utils";
import { toast } from "react-toastify";

/** Body `message` of a planned update. Distinct from a 503 period close. */
export const APP_UNAVAILABLE_MESSAGE = "ServerError.AppUnavailable";

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === "object" && value !== null;

export const isAppUnavailablePayload = (payload: unknown): boolean =>
    isRecord(payload) && payload.message === APP_UNAVAILABLE_MESSAGE;

/** Error toast for a rejected API payload. The maintenance screen already explains AppUnavailable. */
export const toastApiError = (
    payload: unknown,
    toastId = "ServerError.InternalServerError",
    options?: { autoClose?: number; fallback?: string },
) => {
    if (isAppUnavailablePayload(payload)) return;
    const message = isRecord(payload) && typeof payload.message === "string" ? payload.message : "";
    toast.error(`${translationsWithFallback(message, options?.fallback ?? "ServerError.InternalServerError")}`, {
        toastId,
        ...(options?.autoClose !== undefined ? { autoClose: options.autoClose } : {}),
    });
};
